import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore } from 'kts-platform-frame/redux';
import {
    Upload,
    Icon,
    message,
    Progress
} from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))

export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    componentWillMount () {
        ModulesAction.uploadToken(this);
    }

    render() {
        const imageUrl = this.modulesState.companyInfo && this.modulesState.companyInfo.imageUrl;
        const token = this.modulesState.uploadTokenData && this.modulesState.uploadTokenData.token;
        const uploadUrl = this.modulesState.uploadTokenData && this.modulesState.uploadTokenData.uploadUrl;
        const key = this.modulesState.uploadTokenData && this.modulesState.uploadTokenData.keyPrefix;
        const updateLogPercentView = this.modulesState.updateLogPercentView;
        const { user } = MyStore.instance.getState(); 
        return (
            <div className={css['companyLog']}>
                <Upload
                    beforeUpload={this.beforeUpload}
                    data={{key, token}}
                    headers={{Authorization: user.cToken}}
                    action={`//${uploadUrl}`}
                    multiple={false}
                    showUploadList={false}
                    onChange={this.onChange}
                >
                {
                    imageUrl ? (
                        <img 
                            src={imageUrl}
                        />
                    ) : (
                        <div className={css['companyLog-default']}>
                            <Icon type="plus" />
                        </div>
                    )
                }
                {
                    updateLogPercentView &&
                    <Progress percent={this.modulesState.updateLogPercent} size="small"/>
                }
                <h3 className={css['companyLog-title']}>编辑公司标志</h3>
                </Upload>
                <p className={css['companyLog-tip']}>请上传贵公司的标志。支持jpg、jpeg、bmp、png格式图片，大小不超过5M</p>
            </div>
        );
    }

    private beforeUpload = (file) => {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/png');
        if (!isJPG) {
            message.error('只支持jpg、jpeg、bmp、png格式!');
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('图片大小不能超过5M!');
        }
        if (isJPG && isLt2M) {
            this.percentSelfAdd();
        }
        return isJPG && isLt2M;
    }

    private onChange = (info) => { 
        if (info.file.response && info.file.response.body) {
            const imageLogId = info.file.response.body && info.file.response.body.key;
            ModulesAction.imageUpdate({
                imageLogId
            });
            ModulesAction.updatePercent(100);
            ModulesAction.uploadToken(this); 
            setTimeout(() => {
                ModulesAction.updateLogPercentView(false);
                ModulesAction.updatePercent(0);
            }, 1000);
        }
    }

    private percentSelfAdd = () => {
        ModulesAction.updateLogPercentView(true);
        const selfAdd = (): void | boolean => {
            const updateLogPercent = this.modulesState.updateLogPercent;
            if(updateLogPercent < 99) {
                ModulesAction.updatePercent(updateLogPercent + 1);
                selfAdd();
            } else {
                return;
            }
        };
        setTimeout(selfAdd, 100);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/UI.Log.tsx